/* Native Shopify navigation with a shared music position between pages.
 * Never intercept links, forms, history, checkout or account navigation. */
(() => {
  'use strict';
  const config = document.getElementById('wvck-radio-config');
  if (!config || !config.dataset.src || window.WvckRadio) return;
  const inEditor = config.dataset.editor === 'true' || window.Shopify?.designMode;
  const enabledKey = 'wv-music-enabled', positionKey = 'wv-music-position';
  const read = (storage, key, fallback) => { try { return window[storage].getItem(key) ?? fallback; } catch { return fallback; } };
  const write = (storage, key, value) => { try { window[storage].setItem(key, String(value)); } catch {} };
  let audio, wanted, dock, waitingForTap = false, resumeTime = 0;
  const playIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m8 5 11 7-11 7Z"/></svg>';
  const pauseIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>';
  const muteIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 9h4l5-4v14l-5-4H3ZM16 8q5 4 0 8"/></svg>';
  function save() {
    if (!audio) return;
    write('sessionStorage', positionKey, audio.currentTime || 0);
    write('localStorage', enabledKey, wanted);
  }
  function state() {
    return { playing: !audio.paused, muted: audio.muted, volume: audio.volume, waiting: waitingForTap, error: !!audio.error };
  }
  function paint(doc, value) {
    for (const id of ['play', 'wvck-dock-play']) {
      const button = doc.getElementById(id);
      if (button) { button.innerHTML = value.playing ? pauseIcon : playIcon; button.setAttribute('aria-label', value.playing ? 'Pause music' : 'Play music'); button.setAttribute('aria-pressed', String(value.playing)); }
    }
    for (const id of ['mute', 'wvck-dock-mute']) {
      const button = doc.getElementById(id);
      if (button) { button.setAttribute('aria-label', value.muted ? 'Unmute music' : 'Mute music'); button.setAttribute('aria-pressed', String(value.muted)); button.style.opacity = value.muted ? '.5' : '1'; }
    }
    const volume = doc.getElementById('volume'); if (volume) volume.value = value.volume;
    const label = value.error ? 'Track unavailable' : value.playing ? 'Now playing' : value.waiting ? 'Tap to play' : 'Paused';
    const sidebarStatus = doc.getElementById('status'); if (sidebarStatus) sidebarStatus.textContent = label;
    const dockStatus = doc.getElementById('wvck-dock-status'); if (dockStatus) dockStatus.textContent = value.playing ? 'SCUM RADIO' : label;
  }
  function broadcast() {
    const value = state(); paint(document, value);
  }
  async function start() {
    if (!wanted || !audio.paused) return;
    try { await audio.play(); waitingForTap = false; } catch { waitingForTap = true; }
    broadcast();
  }
  function bindControls(doc, controller) {
    for (const id of ['play', 'wvck-dock-play']) {
      doc.getElementById(id)?.addEventListener('click', () => controller.toggle());
    }
    for (const id of ['mute', 'wvck-dock-mute']) {
      doc.getElementById(id)?.addEventListener('click', () => controller.mute());
    }
    doc.getElementById('volume')?.addEventListener('input', e => controller.volume(Number(e.target.value)));
    paint(doc, controller.state());
  }
  audio = document.createElement('audio'); audio.id = 'wvck-persistent-audio'; audio.loop = true; audio.preload = 'metadata';
  audio.src = config.dataset.src; document.body.append(audio);
  wanted = read('localStorage', enabledKey, 'true') !== 'false';
  audio.volume = Math.max(0, Math.min(1, Number(read('localStorage', 'wv-volume', '.5')) || 0));
  audio.muted = read('localStorage', 'wv-muted', 'false') === 'true';
  resumeTime = Number(read('sessionStorage', positionKey, '0')) || 0;
  audio.addEventListener('loadedmetadata', () => { if (resumeTime && Number.isFinite(audio.duration) && audio.duration > 0) audio.currentTime = resumeTime % audio.duration; }, { once: true });
  dock = document.createElement('div'); dock.id = 'wvck-radio-dock'; dock.setAttribute('role', 'group'); dock.setAttribute('aria-label', 'SCUM Radio');
  dock.innerHTML = '<span id="wvck-dock-status">SCUM RADIO</span><button id="wvck-dock-play" type="button" aria-label="Play music">' + playIcon + '</button><button id="wvck-dock-mute" type="button" aria-label="Mute music">' + muteIcon + '</button>';
  document.body.append(dock);

  const radio = window.WvckRadio = {
    state, start, save,
    toggle() { wanted = audio.paused; if (wanted) start(); else audio.pause(); save(); broadcast(); },
    mute() { audio.muted = !audio.muted; write('localStorage', 'wv-muted', audio.muted); broadcast(); },
    volume(value) { audio.volume = Math.max(0, Math.min(1, value)); write('localStorage', 'wv-volume', audio.volume); broadcast(); }
  };
  bindControls(document, radio);
  for (const event of ['play', 'pause', 'volumechange', 'error']) audio.addEventListener(event, broadcast);
  let lastSaved = 0;
  audio.addEventListener('timeupdate', () => { if (Date.now() - lastSaved > 1000) { save(); lastSaved = Date.now(); } });
  window.addEventListener('pagehide', save);
  document.addEventListener('visibilitychange', () => { if (document.hidden) save(); });
  window.addEventListener('pageshow', () => { if (!inEditor) start(); });
  broadcast(); if (wanted && !inEditor) start();
})();
